<template>
  <a-modal title="项目详情"
           :width="1000"
           :visible="visible"
           :destroyOnClose="true"
           :maskClosable="false"
           @cancel="visible=false"
           :footer="null">
    <div>
      <a-card>
        <span slot="tab">项目信息</span>
        <table class="fx-form-view mt-5">
          <tr>
            <th>项目名称</th>
            <td>{{ bidModel.xmmc }}</td>
            <th>项目编号</th>
            <td>{{ bidModel.wbbh || bidModel.xmbh }}</td>
          </tr>
          <tr>
            <th>主办人</th>
            <td>
              <a-tag color="red">{{ bidModel.extras.xmZbrXm }}</a-tag>
            </td>
            <th>协办人</th>
            <td>
              <a-tag v-for="joiner in bidModel.extras.xmXbrXms" color="blue">{{ joiner }}</a-tag>
            </td>
          </tr>
          <tr>
            <th>委托人名称</th>
            <td>{{ bidModel.wtrdwmc }}</td>
            <th>项目属地</th>
            <td>{{ bidModel.extras.xmsdText }}</td>
          </tr>
          <tr>
            <th>项目类型</th>
            <td>{{ bidModel.extras.xmlxText }}</td>
            <th>标的类型</th>
            <td>{{ bidModel.extras.bdlxText }}</td>
          </tr>
          <tr>
            <th>采购预算</th>
            <td>{{ bidModel.cgysje }}万</td>
            <th>币种</th>
            <td>{{ bidModel.extras.bizhongText }}</td>
          </tr>
          <tr>
            <th>登记时间</th>
            <td>{{ bidModel.djsj|dayjs('YYYY-MM-DD HH:mm') }}</td>
            <th>委托时间</th>
            <td>{{ bidModel.wtsj|dayjs('YYYY-MM-DD HH:mm') }}</td>
          </tr>
          <tr>
            <th>公告发布时间</th>
            <td>{{ bidModel.ggfbsj|dayjs('YYYY-MM-DD HH:mm') }}</td>
            <th>调查截止时间</th>
            <td>{{ bidModel.dcjzsj|dayjs('YYYY-MM-DD HH:mm') }}</td>
          </tr>
          <tr>
            <th>需求调查方式</th>
            <td>{{ bidModel.extras.dcfsText }}</td>
            <th>征集方式</th>
            <td>{{ bidModel.extras.zjfsText }}</td>
          </tr>
          <tr>
            <th>采购内容</th>
            <td colspan="3">{{ bidModel.cgnr }}</td>
          </tr>
          <tr>
            <th>备注</th>
            <td colspan="3">{{ bidModel.bz }}</td>
          </tr>
          <tr>
            <th>委托人联系人</th>
            <td>{{ bidModel.wtrlxr }}</td>
            <th>办公电话/传真</th>
            <td>{{ bidModel.wtrbgdh }}</td>
          </tr>
          <tr>
            <th>委托人联系电话</th>
            <td>{{ bidModel.wtrlxrdh }}</td>
            <th>电子邮件</th>
            <td>{{ bidModel.wtrlxryx }}</td>
          </tr>
          <tr>
            <th>地址</th>
            <td colspan="3">{{ bidModel.wtrdwdz }}</td>
          </tr>
        </table>
      </a-card>
    </div>
  </a-modal>
</template>
<script>
import { GetBidDcXmXxById } from '../SurveyBidRequest'

export default {
  name: 'SurveyBidModelView',
  components: {},
  data () {
    return {
      bidModel: {
        extras: {}
      },
      visible: false
    }
  },
  created () {
  },
  methods: {
    // 获取主项目数据
    async loadData (xmid) {
      this.visible = true
      const that = this
      let res = await GetBidDcXmXxById(xmid)
      if (res.code !== 200) {
        that.$message.error('项目数据获取失败')
        return
      }
      that.bidModel = res.result
    },
  }
}
</script>

<style scoped>
</style>
